import { DASH_ENTITY_CODE } from '@studio/constants/library';

const getVideoDescription = (description?: string, formattedDescription?: string, showDashWhenEmpty = false) => {
  if (description === '' && showDashWhenEmpty) {
    return DASH_ENTITY_CODE;
  } else if (formattedDescription === '') {
    return description;
  } else if (formattedDescription) {
    return formattedDescription;
  }

  return description;
};

export default getVideoDescription;
